import React from "react";
import { Outlet } from "react-router-dom";
import NavBar from "../module/navbar/Navbar";
import Footer from "../module/home/Footer";

const Layout = () => {
  return (
    <div className="d-flex flex-column min-vh-100">
      <NavBar  />
    
      <main className="flex-grow-1">
        <Outlet />
      </main>

      <Footer />
    </div>
  );
};

export default Layout;
